<form *ngIf="form" [formGroup]="form">
  <div class="flex justify-center items-center">
    <mat-radio-group
      formControlName="{{ SIGN_UP_FIELDS.ACCOUNT_TYPE }}"
      required
      class="flex"
    >
      <ng-container *ngFor="let type of userTypes; let l = last">
        <mat-radio-button
          [value]="type.value"
          class="block  cursor-pointer {{ l ? 'ml-16px sm:ml-36px' : '' }}"
        >
          {{ type.label | transloco }}
        </mat-radio-button>
      </ng-container>
    </mat-radio-group>
  </div>

  <hr class="my-36px" />

  <ng-container *ngIf="formS.isCompanyAccount; else personalSavingForTmpl">
    <mat-label
      >{{ savingForCompany.title | transloco }}<span>&nbsp;*</span></mat-label
    >

    <mat-radio-group
      formControlName="{{ savingForCompany.type }}"
      required
      class="flex flex-col mt-16px"
    >
      <mat-radio-button
        *ngFor="let option of savingForCompany.options"
        [value]="option.value"
        (click)="checkFocus()"
        class="block cursor-pointer"
      >
        {{ option.label | transloco }}
      </mat-radio-button>
    </mat-radio-group>

    <ib-mat-form-field-wrap
      *ngIf="
        formS.savingForFormCtrl.value === INVESTOR_SAVING_FOR.OTHER &&
        formS.savingForOtherAbstractCtrl
      "
      [formCtrlName]="FORM_FIELDS.SAVING_FOR_OTHER"
      [formCtrl]="form.get(FORM_FIELDS.SAVING_FOR_OTHER)"
      class="ml-42px"
    >
      <mat-form-field>
        <mat-label>Type other case</mat-label>
        <input
          #savingForOtherInput
          type="text"
          matInput
          required
          formControlName="{{ FORM_FIELDS.SAVING_FOR_OTHER }}"
        /> </mat-form-field
    ></ib-mat-form-field-wrap>
  </ng-container>

  <ng-template #personalSavingForTmpl>
    <mat-label>{{ savingFor.title | transloco }}<span>&nbsp;*</span></mat-label>

    <mat-radio-group
      formControlName="{{ savingFor.type }}"
      required
      class="flex flex-col mt-16px"
    >
      <mat-radio-button
        *ngFor="let option of savingFor.options"
        [value]="option.value"
        class="block cursor-pointer"
      >
        {{ option.label | transloco }}
      </mat-radio-button>
    </mat-radio-group>
  </ng-template>

  <hr />

  <ng-container *ngIf="formS.accountType === ACC_TYPE.PERSONAL">
    <mat-label>{{ whatFor.title | transloco }}<span>&nbsp;*</span></mat-label>

    <div>
      <mat-radio-group
        formControlName="{{ whatFor.type }}"
        required
        class="flex flex-col mt-16px"
      >
        <mat-radio-button
          *ngFor="let option of whatFor.options"
          [value]="option.value"
          (click)="checkFocus()"
          class="block cursor-pointer"
        >
          {{ option.label | transloco }}
        </mat-radio-button>
      </mat-radio-group>

      <ib-mat-form-field-wrap
        *ngIf="
          formS.whatForFormCtrl.value === INVESTOR_WHAT_FOR.OTHER &&
          formS.whatForAbstractFormCtrl
        "
        [formCtrlName]="FORM_FIELDS.WHAT_FOR_OTHER"
        [formCtrl]="form.get(FORM_FIELDS.WHAT_FOR_OTHER)"
        class="ml-42px"
      >
        <mat-form-field>
          <mat-label>Type other case</mat-label>
          <input
            #otherInput
            type="text"
            matInput
            required
            formControlName="{{ FORM_FIELDS.WHAT_FOR_OTHER }}"
          /> </mat-form-field
      ></ib-mat-form-field-wrap>

      <hr />
    </div>
  </ng-container>

  <mat-label>{{ howMuch.title | transloco }}<span>&nbsp;*</span></mat-label>

  <div class="grid grid-cols-2 gap-4 mt-8px">
    <div>
      <ib-mat-form-field-wrap
        [formCtrlName]="SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY"
        [formCtrl]="formS.currencyHowMuchAbstractFormCtrl"
        [isSelect]="true"
        [isSelectDropdownOpen]="currency.isDropdownOpen"
      >
        <ib-currency
          #currency
          [parentForm]="form"
          [initByIp]="false"
          [formCtrl]="formS.currencyHowMuchFormCtrl"
          [showPlaceholder]="false"
          class="block w-full"
        ></ib-currency>
      </ib-mat-form-field-wrap>
    </div>
    <div>
      <ib-mat-form-field-wrap
        [formCtrlName]="FORM_FIELDS.HOW_MUCH"
        [formCtrl]="form.get(FORM_FIELDS.HOW_MUCH)"
        [isRightAlignment]="true"
      >
        <mat-form-field class="ib">
          <mat-label>Amount</mat-label>
          <input
            type="number"
            matInput
            formControlName="{{ howMuch.type }}"
            required
          /> </mat-form-field
      ></ib-mat-form-field-wrap>
    </div>

    
  </div>
</form>


